<div class="container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Dados do condomínio</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-condominium-form [mode]="'edit'" [condominiumId]="condominiumId"></app-condominium-form>
      <div class="button-container button-spacing">
        <button mat-raised-button color="accent" (click)="onCancel()">Cancelar</button>
        <button mat-raised-button color="primary" (click)="onSave()">Salvar</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>


